import { render } from "./ShowMail.vue?vue&type=template&id=35986898&scoped=true"
import script from "./ShowMail.vue?vue&type=script&lang=js"
export * from "./ShowMail.vue?vue&type=script&lang=js"

import "./ShowMail.vue?vue&type=style&index=0&id=35986898&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35986898"]])

export default __exports__